import { render } from "./HouseMap.vue?vue&type=template&id=587dd91b"
import script from "./HouseMap.vue?vue&type=script&lang=js"
export * from "./HouseMap.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__